import axios, { AxiosError, AxiosResponse } from 'axios'
import { jwtDecode } from 'jwt-decode'
import history from './history'
import { getToken, removeItem } from './indexDB'
import { notification } from '@greenglobal/greencore.fe.common'
import { MESSAGE } from '@/constants/message'
import { get } from 'lodash'
import { ROUTES } from '@/constants/routesConstants'

const service = axios.create({
  baseURL: decodeURIComponent(`${process.env.REACT_APP_BASE_URL_API}/api` || '')
})

interface CustomErrorData {
  properties: {
    message: string
  }[]
}
let optionsRoot: any

// Request interceptors
service.interceptors.request.use(
  async (config: any) => {
    optionsRoot = { fetchOptions: { cancelNotification: false }, ...config }
    try {
      const access_token = getToken()
      if (access_token) {
        if (config?.headers?.fromCore) {
          config.baseURL = process.env.REACT_APP_CORE_URL_API
        }

        if (config?.headers?.isLogout) {
          config.baseURL = process.env.REACT_APP_SSO_URL
          config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        }

        if (config.headers?.upload_file) config.baseURL = process.env.REACT_APP_UPLOAD_API

        if (!config?.headers?.isLogout) {
          config.headers.Authorization = `Bearer ${access_token}`
        }
        // config.headers.responseType = config.responseType
      }
      // eslint-disable-next-line no-empty
    } catch (_) {}
    return config
  },
  (error: AxiosError) => {
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error: AxiosError) => {
    if (!error?.response) {
      return
    }

    // if (error.status === 400 && !optionsRoot.fetchOptions.cancelNotification) {
    //   const errorData = (error.response.data as CustomErrorData) || MESSAGE.ERROR_SYSTEM

    //   const messagError = errorData.properties[0]?.message
    //   notification({
    //     type: 'error',
    //     message: messagError
    //   })
    // }

    // if (
    //   optionsRoot?.method === 'get' &&
    //   error.response.status >= 400 &&
    //   error.response.status <= 500 &&
    //   !optionsRoot.fetchOptions.cancelNotification
    // ) {
    //   const errorData = MESSAGE.ERROR_SYSTEM

    //   notification({
    //     type: 'error',
    //     message: errorData
    //   })
    // }

    // if (!optionsRoot.fetchOptions.cancelNotification && error.response.status >= 200 && error.response.status <= 300) {
    //   notification({
    //     type: 'success',
    //     message: 'Bạn đã cập nhật thành công dữ liệu'
    //   })

    //   return {
    //     status: 201
    //   }
    // }
    // if (get(error, 'response.status') === 401 || get(error, 'response.status') === 403) {
    //   removeItem()
    //   history.replace('/login')
    //   return Promise.reject(error)
    // }

    if (get(error, 'response.status') === 401) {
      removeItem()
      window.location.replace(`${process.env.REACT_APP_DOMAIN_QTUD_URL_API}${ROUTES.LOGIN}`)

      return Promise.reject(error)
    }

    if (get(error, 'response.status') === 403) {
      window.location.replace('/403')
    }

    return Promise.reject(error)
  }
)

export default service
